/* eslint-disable no-constant-condition */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
class Checkbox extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: this.props.value,
            error: false,
        };
        this.onChange = this.onChange.bind(this);
    }

    componentWillReceiveProps(update) {
        this.setState({ value: update.value });
    }

    onChange(evt) {
        const name = this.props.name;
        const value = evt.target.checked;
        const error = this.props.validate ? this.props.validate(value) : false;

        this.setState({ value, error });
        this.props.onChange({ name, value, error });
    }

    render() {
        return (
          <div>
            <div className={this.props.className}>
                <input
                    checked={this.state.value}
                    type="checkbox"
                    autoFocus={this.props.autoFocus}
                    onChange={this.onChange}
                />
               {this.props.children}

            </div><span style={{ color: 'red' }}>{ this.state.error }</span>
          </div>
        )
    }
}

Checkbox.PropTypes = {
    className: PropTypes.string,
    autoFocus: PropTypes.bool,
    name: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    validate: PropTypes.func,
    onChange: PropTypes.func.isRequired
}

Checkbox.defaultProps = {
  autoFocus: false
};

export default Checkbox;



/** WEBPACK FOOTER **
 ** ./src/components/Checkbox.jsx
 **/